import FontAwesome from 'react-fontawesome';

export const Error: React.FC = () => (
  <div className="u-taCenter u-fs24 u-pt7x">
    <p>
      <FontAwesome name="exclamation-circle" /> Sorry, we're having trouble
      loading your mentions. Please reload the page to try again
    </p>
  </div>
);
